import ESGImage from "Assets/Common/ESG-image.png";
import ScheduleImage from "Assets/Common/GettyImages-14692601921.png";
import PrivatePaperImage from "Assets/Common/PrivatePaper.png";

// eslint-disable-next-line import/no-named-as-default
import PartnerForm from "./Components/PartnerForm";
import * as S from "./styles";

const ConsultingAndManagement = () => {
  return (
    <S.Wrapper>
      <S.Header id="know-more">
        <h1>QUAL O LEGADO A SUA EMPRESA QUER DEIXAR PARA O MUNDO?</h1>
        <p>
          Cada vez mais, os critérios ambientais, sociais e de governança
          corporativa tem somado capital estratégico as empresas, que vem
          buscando se posicionar de forma sólida e estruturada perante a
          sociedade através dos seus investimentos na área de responsabilidade
          social e corporativa.
        </p>
      </S.Header>
      <S.ScheduleWrapper>
        <S.ScheduleContent>
          <h2>AGENDA 2030 DA ONU</h2>
          <p>
            A Agenda 2030 da ONU é um plano global para atingirmos em 2030 um
            mundo melhor para todos os povos e nações. A Assembleia Geral das
            Nações Unidas, realizada em Nova York, em setembro de 2015, com a
            participação de 193 estados membros, estabeleceu 17 objetivos de
            desenvolvimento sustentável.
          </p>
        </S.ScheduleContent>
        <img src={ScheduleImage} alt="" />
      </S.ScheduleWrapper>
      <S.ESGWrapper>
        <S.ESGHeader>
          <h2>ESG</h2>
          <p>Ambiental, Social e Governança Corporativa</p>
        </S.ESGHeader>
        <img src={ESGImage} alt="" />
        <S.ESGContainer>
          <S.ESGContent>
            <h3>Environmental (Ambiental)</h3>
            <p>
              A letra E, em ESG, refere-se a práticas e princípios adotados na
              empresa para a conservação do meio ambiente, como, por exemplo, a
              busca por alternativas sustentáveis, a redução na emissão de
              poluentes, boas práticas com embalagens, geração, cuidado e
              descarte de plásticos e outros materiais e o gerenciamento correto
              do descarte de lixo.
            </p>
          </S.ESGContent>
          <S.ESGContent>
            <h3>Social</h3>
            <p>
              A letra S diz respeito ao compromisso corporativo de trabalhar a
              diversidade, a inclusão e a equidade de gênero na equipe, bem como
              de se pautar no desenvolvimento sustentável das comunidades e de
              promover um ambiente de condições dignas de trabalho para todos.
            </p>
          </S.ESGContent>
          <S.ESGContent>
            <h3>Governance (Governança)</h3>
            <p>
              A letra G se refere à governança corporativa e administrativa de
              um negócio. Desse modo, são tratadas questões relacionadas a
              crescimento, transparência, comunicação sobre performance de
              resultados e questões relacionadas à ética e compliance.
            </p>
          </S.ESGContent>
        </S.ESGContainer>
      </S.ESGWrapper>
      <S.PrivatePaperWrapper>
        <S.PrivatePaperContent>
          <S.PrivatePaperHeader>
            <h2>O PAPEL DO SETOR PRIVADO NA SOCIEDADE</h2>
            <h3>Pequenos gestos podem mudar o mundo</h3>
          </S.PrivatePaperHeader>
          <p>
            Através da definição de uma matriz decisória que norteie de forma
            estruturada e organizada os seus investimentos ligados a
            responsabilidade social corporativa, empresas de todos os portes e
            das mais remotas regiões do País podem fazer a diferença,
            contribuindo, cada qual a sua forma, para uma sociedade mais justa,
            igualitária, diversa e sustentável.
          </p>
        </S.PrivatePaperContent>
        <img src={PrivatePaperImage} alt="" />
      </S.PrivatePaperWrapper>
      <PartnerForm />
    </S.Wrapper>
  );
};

export default ConsultingAndManagement;
